<template>
  <v-layout row wrap>
    <v-flex xs10 offset-xs1 lg8 offset-lg2>
      <v-form v-model="valid" ref="form" @submit.prevent="submit">
        <v-card class="pa-3" v-if="!loading">
          <v-card-text>
            <div class="subheading mb-3">Atualizar Contrato</div>
            <v-layout row>
                <v-flex xs3 lg2>
                    <label class="form-label"
                        >Contrato antigo</label
                    >
                </v-flex>
                <v-flex xs3 lg8>          
                    <v-select
                        disabled
                        v-bind:items="contracts"
                        v-model="form.id"
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs3 lg2>
                <label class="form-label">Contrato novo*</label>
              </v-flex>
              <v-flex xs2 lg8>
                    <v-select
                        autocomplete
                        v-bind:items="contracts"
                        v-model="form.newId"
                        clearable
                        v-on:change="getContractItems"
                        :rules="validation.required"
                    ></v-select>
              </v-flex>
            </v-layout>

            <div class="subheading mt-3">Atualizar Cesta</div>

            <v-layout row 
              v-for="(item, i) in form.items"
              :key=i>
              <v-flex xs3 lg2>
                <label class="form-label">Cesta</label>
              </v-flex>

              <v-flex xs6 lg4 class="pr-3">
                <v-text-field
                  disabled
                  v-model="item.description"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 lg4>
                <v-select
                  :disabled="itemInUseWarning(item)"
                  autocomplete
                  v-bind:items="getContractItems"
                  v-model="form.newContractItems[i]"
                  :rules="firstItemRule(item.id)"
                  clearable
                ></v-select>
              </v-flex>

              <v-flex class="pl-2 pt-1" v-if="itemInUseWarning(item)">
                <span>**</span>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs3 lg2>
                <label class="form-label">Situação da demanda*</label>
              </v-flex>
              <v-flex xs2 lg8>
                <v-select
                  v-model="selectedStates"
                  :items="statesValueText"
                  item-text="text"
                  item-value="value"
                  @change="selectAll"
                  chips
                  multiple
                  :rules="[v => v.length > 0 || 'Obrigatório']"
                  required
                ></v-select>

                <v-checkbox
                  v-model="checkbox"
                  label="Selecione todos"
                  :indeterminate=indeterminateCheckbox()
                  @change="toggleCheckbox"
                ></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout row v-if="msgNotUsed === true">
              <span>**Cesta não utilizada em nenhum sistema ou demanda</span>
            </v-layout>
          </v-card-text>

          <v-card-actions>
            <v-btn
              :loading="saving"
              @click="save"
              color="primary"
            >
              Atualizar
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <app-card-loader></app-card-loader>
        </v-card>

        <v-dialog
          v-model="dialog"
          max-width="290"
        >
          <v-card>
            <v-card-text>
              Pelo menos 1 das cestas em uso não será substituida, deseja mesmo assim inativar o contrato?
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                text
                @click="dialog = false, form.isActive = true, sendData()"
              >
                Não
              </v-btn>

              <v-btn
                color="green"
                text
                @click="dialog = false, form.isActive = false, sendData()"
              >
                Sim
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import utilities from "@/helpers/utilities";
import validation from "@/helpers/validation";
import Contract from "@/helpers/entities/Contract";

export default {
  data() {
    return {
      validation,
      valid: true,

      saving: false,
      loading: true,
      removing: false,

      dialog: false,

      form: Contract.build(),

      selectedStates: [],
      statesValueText: [
        {value: 1, text: "Aberta"},
        {value: 2, text: "Aprovação da Solicitação"},
        {value: 3, text: "Planejamento"},
        {value: 4, text: "Aprovação do Planejamento"},
        {value: 5, text: "Em Execução"},
        {value: 6, text: "Aprovação da Entrega"},
        {value: 7, text: "Encerramento"}
      ],
      checkbox: false,
      msgNotUsed: false,
      updateObj: {},

      inUseNewEmpty: false,
    };
  },

  computed: {
    contracts() {
      const contracts = this.$store.getters.contractsValueText;
      const contracts2 = contracts.filter(item => item.isActive === true);
      return contracts2;
    },
    getContractItems() {
      const items = this.$store.getters.contractItemsValueText;
      let items2 = items.filter(item => item.contractId === this.form.newId);
      items2 = items2.sort((a, b) => {
        if (a.value < b.value) {
          return -1;
        }
        return 0;
      });

      return items2;
    },
  },

  watch: {
    $route: "fetch",
  },

  created() {
    this.fetch();
  },

  methods: {
    async fetch() {
      this.loading = true;

      const id = this.$route.params.id;

      if (!utilities.isEmptyOrZero(id)) {
        await this.$store.dispatch("fetchContract", id);
        this.form = Contract.toForm(this.$store.getters.contract);
      }

      this.loading = false;
    },

    itemInUseWarning(item) {
      if (item.isContractItemInUse === false) {
        this.msgNotUsed = true;
        return true;
      }
      return false;
    },

    selectAll () {
      this.$nextTick(() => {
        if (this.selectedStates.length === this.statesValueText.length) {
          this.checkbox = true;
        } else {
          this.checkbox = false;
        }
      });
    },

    toggleCheckbox () {
      if (this.checkbox === true) {
        this.selectedStates = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.selectedStates = [];
      }
    },

    indeterminateCheckbox () {
      if (this.selectedStates.length > 0 &&
          this.selectedStates.length < this.statesValueText.length) {
        return true;
      }

      return false;
    },

    firstInUseItem() {
      let firstInUseItemId;
      for (let i = 0; i < this.form.items.length; i++) {
        if (this.form.items[i].isContractItemInUse === true) {
          firstInUseItemId = this.form.items[i].id;
          break;
        }
      }

      return firstInUseItemId;
    },

    firstItemRule(id) {
      for (let i = 0; i < this.form.items.length; i++) {
        if (this.form.newContractItems[i]) {
          return [];
        }
      }

      return [v => (!(id === this.firstInUseItem() && !v)) || 'Obrigatório'];
    },

    async sendData () {
      await this.$store.dispatch(
        "updateContract",
        this.form
      );

      this.$router.push({ name: "contractIndex" });
    },

    async save() {
      if (!this.$refs.form.validate()) return;

      this.inUseNewEmpty = false;
      for (let i = 0; i < this.form.items.length; i++) {
        if (this.form.items[i].isContractItemInUse === true && !this.form.newContractItems[i]) {
          this.form.newContractItems[i] = 0;
          this.inUseNewEmpty = true;
        } else if (!this.form.newContractItems[i]) {
          this.form.newContractItems[i] = 0;
        }

        this.form.itemsOldToNew[i] = {
          oldId: this.form.items[i].id,
          newId: this.form.newContractItems[i]
        };
      }

      this.form.demandStates = this.selectedStates;

      if (this.inUseNewEmpty === true) {
        this.dialog = true;
      } else {
        this.form.isActive = false;
        this.sendData();
      }
    },
  },
};
</script>

<style>
.chip.chip--select-multi {
  margin: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/contracts/UpdateContract.vue